import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js';
import axios from 'axios'
import global from './plugins/global.js'
import messages from './i18n'

import VueCryptojs from 'vue-cryptojs'
import { VueEditor, Quill } from 'vue3-editor'
import AOS from 'aos'
import { createI18n } from 'vue-i18n'
import '@fortawesome/fontawesome-free/css/all.css'
import 'aos/dist/aos.css'

import vhpCard from '@/components/cards/vhpCard.vue'
import vhpProductCard from '@/components/cards/vhpProductCard.vue'
import vhpSimpleCard from '@/components/cards/vhpSimpleCard.vue'
import vhpListCard from '@/components/cards/vhpListCard.vue'
import vhpTable from '@/components/table/vhpTable.vue'
import vhpSelect from '@/components/inputs/vhpSelect.vue'
import vhpSlide from '@/components/slide/vhpSlide.vue'
import vhpCardSlide from '@/components/slide/vhpCardSlide.vue'
import vhpProductSlide from '@/components/slide/vhpProductSlide.vue'
import vhpSimpleSlide from '@/components/slide/vhpSimpleSlide.vue'
import vhpEmpty from '@/components/etc/vhpEmpty.vue'
import vhpLoading from '@/components/etc/vhpLoading.vue'
import vhpDialog from '@/components/etc/vhpDialog.vue'
import vhpMenu from '@/components/etc/vhpMenu.vue'
import vhpPlayer from '@/components/video/vhpPlayer.vue'
import vhpBreadcrumb from '@/components/etc/vhpBreadcrumb.vue'
import vhpStepper from '@/components/stepper/vhpStepper.vue'
import vhpTabs from '@/components/tabs/vhpTabs.vue'


const app = createApp(App)
app.use(store)
app.use(router)
app.use(VueCryptojs)
app.use(global)
AOS.init()
app.use(createI18n({
    locale:'kr',
    fallbackLocale:'en',
    messages
}))

var Block = Quill.import('blots/block')
Block.tagName = 'div';
Quill.register(Block)

app.component("vhp-card", vhpCard)
app.component("vhp-product-card", vhpProductCard)
app.component("vhp-simple-card", vhpSimpleCard)
app.component("vhp-list-card", vhpListCard)
app.component("vhp-table", vhpTable)
app.component("vhp-select", vhpSelect)
app.component("vhp-slide", vhpSlide)
app.component("vhp-card-slide", vhpCardSlide)
app.component("vhp-product-slide", vhpProductSlide)
app.component("vhp-simple-slide", vhpSimpleSlide)
app.component("vhp-empty", vhpEmpty)
app.component("vhp-loading", vhpLoading)
app.component("vhp-dialog", vhpDialog)
app.component("vhp-menu", vhpMenu)
app.component("vhp-player", vhpPlayer)
app.component("vhp-breadcrumb", vhpBreadcrumb)
app.component("vhp-stepper", vhpStepper)
app.component("vue-editor", VueEditor)
app.component("vhp-tabs", vhpTabs)


// 개발 환경에서는 로컬 서버, 프로덕션에서는 실제 API 서버 사용
axios.defaults.baseURL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:5000'  // 로컬 개발 서버 (npm run serve 시)
  : 'https://api.vazilcompany.com'  // 프로덕션 서버 (npm run build 시)

// 매 요청마다 Vuex에 저장된 JWT 토큰을 자동으로 Authorization 헤더에 첨부
axios.interceptors.request.use(config => {
  const token = store.state.apiToken
  if (token) {
    if (!config.headers) config.headers = {}
    config.headers['Authorization'] = token
  }
  return config
}, error => Promise.reject(error))

// 401 시 토큰 제거 후 로그인 페이지로 이동
axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.status === 401) {
      store.commit('clearTokens')
      const path = window.location.pathname
      if (path.startsWith('/admin') && path !== '/admin' && path !== '/admin/') {
        window.alert('토큰이 만료되었습니다. 다시 로그인해 주세요.')
        window.location.href = '/admin'
      }
    }
    return Promise.reject(err)
  }
)

app.config.globalProperties.$axios = axios

app.mount('#app')


